import { api } from '../common/api'

interface Wallet {
  // ------支付渠道号
  paymentId: string
  // ------渠道手续费
  fee: string
  // ------应还金额
  repayment: string
  // ------总计应付金额repayment+fee
  totalAmount: string
  name: string
}

interface FPX {
  // ------渠道手续费
  fee: string
  // ------总计应付金额repayment+fee
  totalAmount: string
  // ------应还金额
  repayment: string
  // ------支付渠道号
  paymentId: string
  name: string
}

export interface PaymentInfo {
  // --- 产品说明
  prodDesc: string
  // --- 付款人电邮
  email: string
  // --- 电子钱包列表
  ewallet: Wallet[]

  paymentAmount: string

  // ---合同号
  ano: string
  // ---付款人手机号
  mobile: string
  // ---付款人姓名
  name: string
  // --- 银行渠道列表
  fpx: FPX[]
}

export interface ReqPaymentInfo {
  // 渠道代码	ipay88
  channel: string
  // 还款方式	 1-提前结清，2-正常还款（用这个）
  mode: string
  // 合同号
  ano: string
}

export const getPaymentInfo = (ano: string) => {
  const params: ReqPaymentInfo = {
    channel: 'ipay88',
    mode: '2',
    ano,
  }
  return api.get<PaymentInfo>('/customer/acc/payment/info', { params })
}

interface ReqPreflight {
  // 客户电话
  phone: string
  // 邮箱
  email: string
  // 支付金额	 为保证精度传字符串，保留两位小数，例如：2000.00
  totleAmount: string
  actualCurrency: string
  // 手续费
  poundage: string
  // amount: string
  // 用户姓名
  userName: string
  // 订单号
  orderNo: string
  // 支付方式
  paymentId: string
  channel: 'Portal' | 'Mobile'
}

interface ResponsePreflight {
  // 支付流水号
  refNo: string
  // 对应ipay88的responseURL,这个时ipay88支付完成后的页面回跳我方地址
  responseURL: string
  // 某响应参数	200表示生成签名成功，其他提示失败
  code: number
  // 错误信息	200表示生成签名成功，其他提示失败
  errorMessage: string
  // 对应ipay88的backendURL，这个是结果回调我方后台地址
  backendURL: string
  // 签名
  signature: string

  merchantCode: string

  // 总金额 例如：2,345.92
  totleAmount: string
}

// 正式地址
export const preflight = (params: ReqPreflight) => api.post<ResponsePreflight>('//e-shenma.com.my/payment/enquiry', params, { usePayload: true })
// 测试地址
//export const preflight = (params: ReqPreflight) => api.post<ResponsePreflight>('//sit01.e-shenma.com.my/payment/enquiry', params, { usePayload: true })

export interface ReqPayment {
  MerchantCode: string
  PaymentId: string
  RefNo: string
  Amount: string
  Currency: string
  ProdDesc: string
  UserName: string
  UserEmail: string
  UserContact: string
  Remark: string
  Lang: string
  SignatureType: string
  Signature: string
  ResponseURL: string
  BackendURL: string
}

interface ResponsePayment { }

export const makePayment = (params: ReqPayment) => api.post<ResponsePayment>('https://payment.ipay88.com.my/epayment/entry.asp', params)

// 正式地址
export const queryPayment = (refNo: string) => api.get('//e-shenma.com.my/payment/enquiry/' + refNo, { usePayload: true })
// 测试地址
//export const queryPayment = (refNo: string) => api.get('//sit01.e-shenma.com.my/payment/enquiry/' + refNo, { usePayload: true })

export const checkPayment = (ano: string) => api.get('/customer/acc/payment/check', { params: { ano }, usePayload: true })


// interface ListParam {
//   // 当前页码（非必填，1开始，默认1）
//   page: number
//   // 支付渠道, 非必填（暂时先传1）：1 - ipay88，2 - xkiosk
//   channel?: string
//   // 支付状态	status	string	非必填（暂时没用）
//   // 每页容量（非必填，默认99）	size	string	
// }

export interface PaymentListItem {
  // ------合同编号
  agreementNo: string
  // ------支付发起渠道
  channel: string
  // ------支付完成时间
  updateTime: string
  // ------关联交易流水号
  refNo: string
  // ------支付发起时间
  date: string
  // ------支付状态
  status: string
  // ------支付金额
  amount: string
  // ------支付方式
  mode: string
}


export const listingPayment = () => api.get<string[]>('/customer/payment/anos')

interface HistoryParam {
  // 当前页码（非必填，1开始，默认1）
  page: number
  // 支付渠道	channel	string	非必填（暂时先传1）：1-ipay88，2-xkiosk
  channel: 1
  // 支付状态	status	string	非必填（暂时没用）
  // 每页容量（非必填，默认99）	size	string	
  size: number
}

export interface HistoryListItem {
  // 合同编号
  agreementNo: string	
  // ------支付发起渠道
  channel: string	
  // ------支付完成时间
  updateTime: string	
  // ------关联交易流水号
  refNo: string	
  // ------支付发起时间
  date: string	
  // ------支付状态
  status: string	
  // ------支付金额
  amount: string	
  // ------支付方式
  mode: string
}

interface HistoryListResp {
  page: number
  dataList: HistoryListItem[]
  total: number
  size: number 
}

export const getPaymentHistory = (params: HistoryParam) => {
  console.log('fetch', params)
  return api.get<HistoryListResp>('/customer/payment/list', { params })
}